import {Component, Input, OnChanges} from '@angular/core';

@Component({
	selector: 'app-read-more-less-text',
	templateUrl: './read-more-less-text.component.html',
	styleUrls: ['./read-more-less-text.component.scss'],
})

export class ReadMoreLessTextComponent implements OnChanges {
	@Input() public text: string = '';
	@Input() public maxLength: number = 100;
	public currentText: string;
	public hideToggle: boolean = true;

	public isCollapsed: boolean = true;

	constructor() {

	}

	public toggleView(): void {
		this.isCollapsed = !this.isCollapsed;
		this.determineView();
	}

	public determineView(): any {
		if (!this.text || this.text.length <= this.maxLength) {
			this.currentText = this.text;
			this.isCollapsed = false;
			this.hideToggle = true;

			return;
		}
		this.hideToggle = false;
		if (this.isCollapsed) {
			this.currentText = this.text.substring(0, this.maxLength) + '...';

			return;
		}
		this.currentText = this.text;

	}

	public ngOnChanges(): void {
		this.determineView();
	}
}
